import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Card, Section } from 'styleguide';

import { hasSegmentAccess, useHasPermission } from 'commons/auths';
import { View } from 'dashboard/components/View';

const SegmentUpsell = () => {
  return (
    <Section>
      <Card id="segments-pro-splash-mount" />
    </Section>
  );
};

export const SegmentGate = ({ children }) => {
  const canSegmentAccess = useHasPermission(hasSegmentAccess);
  if (canSegmentAccess) {
    return children;
  }

  return <SegmentUpsell />;
};

SegmentGate.propTypes = {
  children: PropTypes.node,
};

export const SegmentPageGate = ({ children }) => {
  const canSegmentAccess = useHasPermission(hasSegmentAccess);
  if (canSegmentAccess) {
    return children;
  }

  return (
    <View titleLvl1="All Segments">
      <Helmet>
        <title>Segments | Candu</title>
        <meta name="description" content="Candu's Segments" />
      </Helmet>
      <SegmentUpsell />
    </View>
  );
};

SegmentPageGate.propTypes = {
  children: PropTypes.node,
};
